// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-field-container',
    props: {
        member: {
            type: String,
            required: false,
            default: ''
        },
    },
    data: () => ({
        internalValidator: null,
        errorMessage: ''
    }),
    beforeMount() {
        this.internalValidator = utils.findForm(this);
    },
    computed: {
        hasObjectMember() {
            if (utils.isNullOrEmpty(this.member)) {
                return false;
            }
            return true;
        },
        validationState() {
            if (utils.isNullOrEmpty(this.errorMessage)) {
                return "valid";
            }
            else {
                return "invalid";
            }
        }
    },
    methods: {
        onFocusOut(event) {
            //Value
            if (this.hasObjectMember) {
                this.internalValidator?.validateFieldOnLeft(this.member);
            }
            //Event
            this.$emit('validate', event);
        },
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
    }
});
// #endregion
